import * as CookieConsent from "vanilla-cookieconsent";

/**
 * All config. options available here:
 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
 */
CookieConsent.run({
    disablePageInteraction: true,
    // root: 'body',
    // autoShow: true,
    // disablePageInteraction: true,
    // hideFromBots: true,
    // mode: 'opt-in',
    // revision: 0,

    // cookie: {
    //     name: 'cc_cookie',
        // domain: location.hostname,
        // path: '/',
        // sameSite: "Lax",
        // expiresAfterDays: 365,
    // },

    // https://cookieconsent.orestbida.com/reference/configuration-reference.html#guioptions
    guiOptions: {
        consentModal: {
            layout: 'box wide',
            position: 'bottom center',
            equalWeightButtons: false,
            flipButtons: false,
            transition: 'slide'
        },
        preferencesModal: {
            layout: 'box',
            equalWeightButtons: false,
            flipButtons: false,
            transition: 'slide'
        }
    },

    onFirstConsent: ({cookie}) => {
        registerCookiePreference(cookie)
    },

    onConsent: ({cookie}) => {
        updateGtagConsent();
        updateFBConsent();
        if (CookieConsent.acceptedCategory('targeting') && !window._fbPageViewFired) {
            fbq('track', 'PageView', {}, {eventID: window.fbEventId || undefined});
            window._fbPageViewFired = true;
        }
    },

    onChange: ({changedCategories, changedServices}) => {
        registerCookiePreference(changedCategories)
        updateGtagConsent();
        updateFBConsent();
        location.reload();
    },

    // onModalReady: ({modalName}) => {
    //     console.log('ready:', modalName);
    // },
    //
    // onModalShow: ({modalName}) => {
    //     console.log('visible:', modalName);
    // },
    //
    // onModalHide: ({modalName}) => {
    //     console.log('hidden:', modalName);
    // },

    categories: {
        necessary: {
            enabled: true,  // this category is enabled by default
            readOnly: true  // this category cannot be disabled
        },
        analytics: {
            autoClear: {
                cookies: [
                    {
                        name: /^_ga/,   // regex: match all cookies starting with '_ga'
                    },
                    {
                        name: '_gid',   // string: exact cookie name
                    }
                ]
            },

            // https://cookieconsent.orestbida.com/reference/configuration-reference.html#category-services
            // services: {
                // ga: {
                //     label: 'Google Analytics',
                //     onAccept: () => {},
                //     onReject: () => {}
                // },
                // youtube: {
                //     label: 'Youtube Embed',
                //     onAccept: () => {},
                //     onReject: () => {}
                // },
            // }
        },
        targeting: {}
    },

    language: {
        default: 'it',
        translations: {
            it: {
                consentModal: {
                    title: ' I Cookie rendono le cose migliori!',
                    description: 'Utilizziamo cookie e identificatori di prima o terza parte con il tuo consenso e/o nostro interesse legittimo, allo scopo di immagazzinare o accedere alle informazioni sul tuo dispositivo, per raccogliere dati personali degli utenti per sviluppare e migliorare prodotti, nonché per visualizzare e misurare pubblicità  nostra e/o di terzi e/o contenuti personalizzati basati sulla tua navigazione (ad esempio le pagine visitate).', //
                    acceptAllBtn: 'Accetto tutti i Cookie',
                    acceptNecessaryBtn: 'Rifiuta tutti',
                    showPreferencesBtn: 'Impostazioni',
                    equalWeightButtons: false
                    // closeIconLabel: 'Reject all and close modal',
                },
                preferencesModal: {
                    title: 'Centro preferenze sulla privacy',
                    acceptAllBtn: 'Accetta tutti',
                    acceptNecessaryBtn: 'Rifiuta tutti',
                    savePreferencesBtn: 'Salva le impostazioni',
                    closeIconLabel: 'Chiudi',
                    serviceCounterLabel: 'Servizio|Servizi',
                    equalWeightButtons: false,
                    sections: [
                        {
                            title: 'Opzioni Cookie',
                            description: 'Questo sito Web utilizza cookie essenziali per garantirne il corretto funzionamento e cookie di tracciamento per capire come interagisci con esso. Quest\'ultimo sarà impostato solo previo consenso.'
                        },
                        {
                            title: 'Cookie strettamente necessari',
                            description: 'Questi cookie sono necessari per il funzionamento del sito e non possono essere disattivati nei nostri sistemi. Di solito vengono impostati solo in risposta alle azioni da te effettuate che costituiscono una richiesta di servizi, come l\'impostazione delle preferenze di privacy, l\'accesso o la compilazione di moduli. È possibile impostare il browser per bloccare o avere avvisi riguardo questi cookie, ma di conseguenza alcune parti del sito non funzioneranno. Questi cookie non archiviano informazioni personali.',
                            linkedCategory: 'necessary',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Dominio',
                                    desc: 'Descrizione',
                                },
                                body: [
                                    {
                                        name: 'october_session',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Conserva lo stato della sessione del visitatore tra le richieste di pagina.',
                                    },
                                    {
                                        name: 'cc_cookie',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Memorizza lo stato del consenso ai cookie dell\'utente per il dominio corrente.',
                                    },
                                    {
                                        name: 'mdp-readabler-hide',
                                        domain: window.location.hostname,
                                        desc: 'Memorizza lo stato del plugin per l\'accesibilità',
                                    },
                                ]
                            }
                        },
                        {
                            title: 'Cookie di analisi e prestazione',
                            description: 'Questi cookie ci permettono di contare le visite e fonti di traffico in modo da poter misurare e migliorare le prestazioni del nostro sito. Ci aiutano a sapere quali sono le pagine più e meno popolari e vedere come i visitatori si muovono intorno al sito. Tutte le informazioni raccolte dai cookie sono aggregate e quindi anonime. Se non consenti questi cookie, non sapremo quando hai visitato il nostro sito.',
                            linkedCategory: 'analytics',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Dominio',
                                    desc: 'Descrizione'
                                },
                                body: [
                                    {
                                        name: '_ga',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet',
                                    },
                                    {
                                        name: '_gid',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet',
                                    },
                                    {
                                        name: '_gat',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Utilizzato da Google Analytics per limitare la frequenza delle richieste',
                                    },
                                    {
                                        name: 'ssupp.visits',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Identifica l\'ultima pagina visitata dal visitatore. Questo è usato per rendere la funzione chat-box più rilevante.',
                                    }
                                ]
                            }
                        },
                        {
                            title: 'Cookie per pubblicità mirata',
                            description: 'Questi cookie possono essere impostati tramite il nostro sito dai nostri partner pubblicitari. Possono essere utilizzati da queste aziende per costruire un profilo dei tuoi interessi e mostrarti annunci pertinenti su altri siti. Non memorizzano direttamente informazioni personali, ma sono basati unicamente sull/individuazione del tuo browser e del tuo dispositivo internet. Se non si accettano questi cookie, riceverai una pubblicità meno mirata.',
                            linkedCategory: 'targeting',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Domain',
                                    desc: 'Descrizione'
                                },
                                body: [
                                    {
                                        name: '_fbp',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Utilizzato per tracciare i visitatori su più siti Web, al fine di visualizzare annunci pubblicitari recenti pertinenti in base alle preferenze del visitatore.  ',
                                    },
                                    /*{
                                        name: 'mtc_id',
                                        domain: window.location.hostname,
                                        desc: "HTTP - Utilizzato per tracciare i visitatori su più siti Web, al fine di visualizzare annunci pubblicitari recenti pertinenti in base alle preferenze del visitatore.  ",
                                    },
                                    {
                                        name: 'mautic_device_id',
                                        domain: window.location.hostname,
                                        desc: "HTTP - Utilizzato per identificare il visitatore attraverso le visite e i dispositivi. Ciò consente al sito web di presentare il visitatore con Pubblicità pertinente - Il servizio è fornito da centri pubblicitari di terze parti, che facilitano le offerte in tempo reale per gli inserzionisti. ",
                                    },
                                    {
                                        name: 'mautic_referer_id',
                                        domain: window.location.hostname,
                                        desc: "HTTP - Raccoglie informazioni sul comportamento degli utenti su più siti web. Queste informazioni vengono utilizzate per ottimizzare la pertinenza della pubblicità sul sito web.  ",
                                    },
                                    {
                                        name: 'mtc_sid',
                                        domain: window.location.hostname,
                                        desc: "HTTP - Utilizzato per tracciare i visitatori su più siti Web, al fine di visualizzare annunci pubblicitari recenti pertinenti in base alle preferenze del visitatore.  ",
                                    }*/
                                ]
                            }
                        },{
                            title: 'Maggiori informazioni',
                            description: 'Per maggiori informazioni consulta la nostra <a href="/privacy-policy" class="cc-link">privacy policy</a> e la <a href="/cookie-policy" class="cc-link">cookie policy</a>.',
                        }
                    ]
                }
            }
        }
    }
});

const updateGtagConsent = () => {
    const consentMode = {
        'ad_storage': CookieConsent.acceptedCategory('targeting') ? 'granted' : 'denied',
        'ad_user_data': CookieConsent.acceptedCategory('targeting') ? 'granted' : 'denied',
        'ad_personalization': CookieConsent.acceptedCategory('targeting') ? 'granted' : 'denied',
        'analytics_storage': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
        'functionality_storage': CookieConsent.acceptedCategory('functional') ? 'granted' : 'denied',
        'personalization_storage': CookieConsent.acceptedCategory('functional') ? 'granted' : 'denied',
        'security_storage': 'granted', //necessary
        // 'region': ['IT', 'ES','AL','AT','BE','BG']
        // 'wait_for_update': 500
    };

    gtag('consent', 'update', consentMode);
};

const updateFBConsent = () => {
    fbq('consent', CookieConsent.acceptedCategory('targeting') ? 'grant' : 'revoke');
};

function registerCookiePreference() {
    let cookiEntries = {
        'targeting': CookieConsent.acceptedCategory('targeting') ? '1' : '0',
        'analytics': CookieConsent.acceptedCategory('analytics') ? '1' : '0',
    }

    $.request('onLogEntries',{
        data: {cookiEntries: cookiEntries},
    })
}



window.trackGtagEvent = function(eventName = "form_contatti_generico", dataPush = ""){
    if (CookieConsent.acceptedCategory('analytics')) {
        gtag('event', eventName, dataPush);
    }
};

window.trackFbqEvent = function(eventName = "Lead", dataPush = ""){
    if (CookieConsent.acceptedCategory('targeting')) {
        if (eventName == "Lead") {
            fbq('track', 'Lead');
        } else {
            fbq('trackCustom', eventName);
        }
    }
};

if (CookieConsent.acceptedCategory('targeting')) {
    fbq('consent', 'grant');
}
